module.exports = __webpack_public_path__ + "assets/images/project/brunei-desktop.jpg?v=dff1c965";